(function(){
    'use strict';

    var $headerSearch = $('.smp-js-page-header-search');

    if($headerSearch.length){

        var $clearTextBtn = $headerSearch.find('button.smp-page-header__clear-text'),
            $searchField = $headerSearch.find('input[type="text"]');

            $searchField.keyup(function(){

                if($(this).val() != ""){
                    if(!$clearTextBtn.hasClass('active')){
                        $clearTextBtn.addClass('active');
                    }
                }else {
                    $clearTextBtn.removeClass('active');
                }

            });

            $clearTextBtn.click(function(){
                $searchField.val('');
                $searchField.text('');
                $(this).removeClass('active');
                return false;

            });

    }
}());
